/**
 * #1106 — Opportunity rich HTML field registry (re-exports multiline registry).
 */

import { isMultilineRichHtmlFieldKey } from './multilineRichHtmlFields';

export {
  DEFAULT_MULTILINE_RICH_HTML_MAX,
  MULTILINE_RICH_HTML_FIELD_LIMITS,
  PROJECT_DESCRIPTION_RICH_HTML_MAX,
  isMultilineRichHtmlFieldKey,
  multilineRichHtmlMaxLength,
} from './multilineRichHtmlFields';

export const OPPORTUNITY_RICH_HTML_FIELD_KEYS = [
  'oppProjectDescription',
  'siteAdditionalSiteInformation',
] as const;

export type OpportunityRichHtmlFieldKey =
  (typeof OPPORTUNITY_RICH_HTML_FIELD_KEYS)[number];

export function isOpportunityRichHtmlFieldKey(
  key: string,
): key is OpportunityRichHtmlFieldKey {
  return isMultilineRichHtmlFieldKey(key);
}

export const SITESCOPE_ATTACHMENT_SRC_PATTERN =
  /^sitescope-attachment:\/\/\d+\/?$/;

export const SITESCOPE_ATTACHMENT_PENDING_SRC_PATTERN =
  /^sitescope-attachment-pending:\/\/[\w-]+$/;

export function isAllowedSitescopeAttachmentSrc(src: string): boolean {
  const trimmed = src.trim();
  return (
    SITESCOPE_ATTACHMENT_SRC_PATTERN.test(trimmed) ||
    SITESCOPE_ATTACHMENT_PENDING_SRC_PATTERN.test(trimmed)
  );
}
